import { v4 as uuidv4 } from "uuid"
import { IEdamaFoodSearchResult, IEdamaIngredientOption } from "model/food/types/edama.types"
import {
  CreateRecentIngredientPayload,
  IRecentIngredient,
} from "model/food/types/recentIngredient.types"

/**
 * Convert IEdamaFoodSearchResult to CreateRecentIngredientPayload
 * Used when saving an EDAMAM ingredient to recent ingredients
 * Note: EDAMAM doesn't have imageId, so we pass imageUrl/previewImageUrl directly
 */
export const getRecentIngredientPayloadFromFood = (
  food: IEdamaFoodSearchResult,
): CreateRecentIngredientPayload => ({
  foodId: food.id,
  name: food.name,
  source: "EDAMAM",
  portion: food.portion,
  unit: food.unit,
  calorie: food.calorie,
  protein: food.protein,
  fat: food.fat,
  carbohydrate: food.carbohydrate,
  gram: food.gram,
  units: food.units,
  brand: food.brand,
  imageUrl: food.imageUrl,
  previewImageUrl: food.previewImageUrl,
})

/**
 * Convert IRecentIngredient to IEdamaIngredientOption
 * Used when adding a recent ingredient to MyFood ingredients list
 */
export const getEdamaIngredientOptionFromRecentIngredient = (
  ingredient: IRecentIngredient,
): IEdamaIngredientOption => ({
  foodId: ingredient.foodId,
  uuid: uuidv4(),
  name: ingredient.name,
  source: "EDAMAM",
  portion: ingredient.portion,
  unit: ingredient.unit,
  calorie: ingredient.calorie,
  protein: ingredient.protein,
  fat: ingredient.fat,
  carbohydrate: ingredient.carbohydrate,
  gram: ingredient.gram,
  units: ingredient.units,
  brand: ingredient.brand,
  imageUrl: ingredient.imageUrl,
  previewImageUrl: ingredient.previewImageUrl,
})

/**
 * Convert IEdamaIngredientOption to CreateRecentIngredientPayload
 * Used when saving a modified recent ingredient as a new recent ingredient entry
 */
export const getRecentIngredientPayloadFromIngredientOption = (
  ingredientOption: IEdamaIngredientOption,
): CreateRecentIngredientPayload => ({
  foodId: ingredientOption.foodId,
  name: ingredientOption.name,
  source: "EDAMAM",
  portion: ingredientOption.portion,
  unit: ingredientOption.unit,
  calorie: ingredientOption.calorie,
  protein: ingredientOption.protein,
  fat: ingredientOption.fat,
  carbohydrate: ingredientOption.carbohydrate,
  gram: ingredientOption.gram,
  units: ingredientOption.units,
  brand: ingredientOption.brand,
  imageUrl: ingredientOption.imageUrl,
  previewImageUrl: ingredientOption.previewImageUrl,
})

/**
 * Convert RecentIngredientType to CreateRecentIngredientPayload
 * Used when quick-adding a recent ingredient to update its timestamp
 * Note: We extract all fields except 'id' since that's the recent ingredient record ID
 */
export const getRecentIngredientPayloadFromRecentIngredient = (
  ingredient: IRecentIngredient,
): CreateRecentIngredientPayload => ({
  foodId: ingredient.foodId,
  name: ingredient.name,
  source: "EDAMAM",
  portion: ingredient.portion,
  unit: ingredient.unit,
  calorie: ingredient.calorie,
  protein: ingredient.protein,
  fat: ingredient.fat,
  carbohydrate: ingredient.carbohydrate,
  gram: ingredient.gram,
  units: ingredient.units,
  brand: ingredient.brand,
  imageUrl: ingredient.imageUrl,
  previewImageUrl: ingredient.previewImageUrl,
})
